import { Utils } from '../../../../../common/js/Utils';
import { supertypeClass, Bindable, Remoteable, Persistable, Supertype } from '@haventech/amorphic';
import { CdmService } from '../../../../../common/js/services/CdmService';
import { RateClasses, NonTobaccoPlus } from '../../../../../common/js/static/RateClasses';
import { HtmlPdfUtils } from '../../HtmlPdfUtils';
import { IllustrationRequest } from '../../IllustrationRequest';
import { CPPolicyRateClassDescriptions } from '../../../../js/interfaces/CoverpathTypes';
import { CoverpathUtils } from '../../../../js/static/CoverpathUtils';
import { constants } from '../../basicIllustration/templates/constantsForPdf';
import { StateSpecification } from '../../basicIllustration/templates/common/StateSpecification';
export class CssStyle {
  HtmlPdfFooterStyle?: string = '';
}

class Footer {
  HtmlPdfFooterTemplate: string = '';
  HtmlPdfFooterLastPage: string = '';
  css: CssStyle = new CssStyle();
}

@supertypeClass({ toClient: false, toServer: true })
export class HtmlPdfFooter extends Bindable(Remoteable(Persistable(Supertype))) {
  private agentStateLicenseService: CdmService;

  private templateFolder = './apps/coverpath-common/classes/wholelife/components/footer/templates/';
  constructor() {
    super();
    this.agentStateLicenseService = new CdmService();
  }

  Footer;

  async getFilledFooter(illustrationRequest: IllustrationRequest, last: boolean = false) {
    this.Footer = await HtmlPdfUtils.getContent(this.templateFolder, new Footer());

    if (last) {
      this.Footer.HtmlPdfFooterLastPage = this.replaceHtmlContent(
        illustrationRequest,
        this.Footer.HtmlPdfFooterLastPage
      );
      this.Footer.HtmlPdfFooterLastPage = await this.replaceHtmlContentAgentInfo(
        illustrationRequest,
        this.Footer.HtmlPdfFooterLastPage
      );
      return this.Footer.HtmlPdfFooterLastPage;
    } else {
      this.Footer.HtmlPdfFooterTemplate = this.replaceHtmlContent(
        illustrationRequest,
        this.Footer.HtmlPdfFooterTemplate
      );
      this.Footer.HtmlPdfFooterTemplate = await this.replaceHtmlContentAgentInfo(
        illustrationRequest,
        this.Footer.HtmlPdfFooterTemplate
      );

      return this.Footer.HtmlPdfFooterTemplate;
    }
  }

  // replace the HTML content for coverpage with illustration data
  replaceHtmlContent(illustrationRequest: IllustrationRequest, htmlContent) {
    let underwritingClass;
    let rateClassDescription;

    if (illustrationRequest.rateClass === RateClasses.NON_TOBACCO_PLUS.stringCode) {
      underwritingClass = NonTobaccoPlus.rateClassDescription.tobaccoDescription;
      rateClassDescription = NonTobaccoPlus.rateClassDescription;
    } else {
      underwritingClass = CPPolicyRateClassDescriptions[illustrationRequest.rateClass].tobaccoDescription;
      rateClassDescription = CPPolicyRateClassDescriptions[illustrationRequest.rateClass];
    }

    const rateClass = RateClasses.findByStringCode(illustrationRequest.rateClass);
    let underWritingClassForFooter = RateClasses.isTableRated(rateClass.code)
      ? rateClassDescription.longDescription
      : rateClassDescription.tobaccoDescription;

    if (HtmlPdfUtils.isInsuredJuvenile(illustrationRequest)) {
      underwritingClass = 'Juvenile';
      underWritingClassForFooter = 'Juvenile';
    }

    return (
      htmlContent
        .replace(/{{ClientFirstName}}/g, illustrationRequest.customerPerson.firstName)
        .replace(/{{ClientLastName}}/g, illustrationRequest.customerPerson.lastName)
        .replace(/{{CurrentDate}}/g, HtmlPdfUtils.getDateInPrettyFormat())
        .replace(/{{PolicyNumber}}/g, illustrationRequest.policyNumber)
        .replace(
          /{{ClientGender}}/g,
          HtmlPdfUtils.getGenderInPrettyFormat(illustrationRequest.gender, illustrationRequest.state)
        )
        .replace(
          /{{ClientAge}}/g,
          CoverpathUtils.getInsuranceAge(illustrationRequest.dob, illustrationRequest.startDate)
        )
        //we use the insuranceQuote datamodel for the descriptions, but look up the value as specified in the request
        .replace(/{{UnderwritingClass}}/g, underwritingClass)
        .replace(/{{UnderwritingClassForFooter}}/g, underWritingClassForFooter)
        .replace(/{{Version}}/g, constants.CPVersion)
        .replace(/{{State}}/g, illustrationRequest.state)
    );
  }

  async replaceHtmlContentAgentInfo(illustrationRequest: IllustrationRequest, htmlContent) {
    const agentLicenseNumber = await this.getStateLicenseContent(illustrationRequest);

    return htmlContent
      .replace(/{{AgentFirstName}}/g, illustrationRequest.agent.firstName)
      .replace(/{{AgentLastName}}/g, illustrationRequest.agent.lastName)
      .replace(/{{AgentAddressLine1}}/g, illustrationRequest.agent.address.street)
      .replace(/{{AgentCity}}/g, illustrationRequest.agent.address.city)
      .replace(/{{AgentState}}/g, illustrationRequest.agent.address.state)
      .replace(/{{AgentZipCode}}/g, illustrationRequest.agent.address.zip)
      .replace(/{{AgentLicenseNumber}}/g, agentLicenseNumber)
      .replace(/{{AgentPhoneNumber}}/g, HtmlPdfUtils.getAgentPhone(illustrationRequest));
  }

  async getStateLicenseContent(illustrationRequest: IllustrationRequest): Promise<string> {
    if (
      StateSpecification.LicenseRequiredStates.includes(illustrationRequest.state) &&
      !illustrationRequest.isWholesaler
    ) {
      let { licenseNumber } = illustrationRequest;
      if (!licenseNumber) {
        licenseNumber = await this.fetchStateLicense(illustrationRequest.agent.producerId, illustrationRequest.state);
      }
      return `<p class="p3 ft3">Agent License Number: ${licenseNumber} </p>`;
    }
    return '';
  }

  private async fetchStateLicense(producerId: string, state: string): Promise<string> {
    const licenses = await this.agentStateLicenseService.getStateLicenses(producerId);
    const stateLicense = licenses.find((license) => license.state === state);
    if (stateLicense) {
      return stateLicense.licenseNumber;
    }
  }
}
